// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file live178/v1/common.proto (package live178.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file live178/v1/common.proto.
 */
export const file_live178_v1_common: GenFile = /*@__PURE__*/
  fileDesc("ChdsaXZlMTc4L3YxL2NvbW1vbi5wcm90bxIKbGl2ZTE3OC52MSI0CgtQYWdlUmVxdWVzdBIRCglwYWdlX3NpemUYASABKAUSEgoKcGFnZV90b2tlbhgCIAEoCSI7CgxQYWdlUmVzcG9uc2USFwoPbmV4dF9wYWdlX3Rva2VuGAEgASgJEhIKCnRvdGFsX3NpemUYAiABKAMiLwoFTW9uZXkSEAoIY3VycmVuY3kYASABKAkSFAoMYW1vdW50X21pbm9yGAIgASgDIkoKD09wZXJhdGlvblJlc3VsdBIQCghhY2NlcHRlZBgBIAEoCBITCgtyZXNvdXJjZV9pZBgCIAEoCRIQCghyZXZpc2lvbhgDIAEoCSJmCg9SZXF1ZXN0TWV0YWRhdGESEgoKcmVxdWVzdF9pZBgBIAEoCRIQCgh0cmFjZV9pZBgCIAEoCRItCglzZXJ2ZWRfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wImAKDUF1ZGl0U25hcHNob3QSJwoGYmVmb3JlGAEgASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdBImCgVhZnRlchgCIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3QiNwoFQWN0b3ISCgoCaWQYASABKAkSDAoEdHlwZRgCIAEoCRIUCgxkaXNwbGF5X25hbWUYAyABKAlCOVo3Z2l0aHViLmNvbS9saXZlMTc4L3BsYXRmb3JtL2dlbi9nby9saXZlMTc4L3YxO2xpdmUxNzh2MWIGcHJvdG8z", [file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message live178.v1.PageRequest
 */
export type PageRequest = Message<"live178.v1.PageRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;
};

/**
 * Describes the message live178.v1.PageRequest.
 * Use `create(PageRequestSchema)` to create a new message.
 */
export const PageRequestSchema: GenMessage<PageRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_common, 0);

/**
 * @generated from message live178.v1.PageResponse
 */
export type PageResponse = Message<"live178.v1.PageResponse"> & {
  /**
   * @generated from field: string next_page_token = 1;
   */
  nextPageToken: string;

  /**
   * @generated from field: int64 total_size = 2;
   */
  totalSize: bigint;
};

/**
 * Describes the message live178.v1.PageResponse.
 * Use `create(PageResponseSchema)` to create a new message.
 */
export const PageResponseSchema: GenMessage<PageResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_common, 1);

/**
 * @generated from message live178.v1.Money
 */
export type Money = Message<"live178.v1.Money"> & {
  /**
   * @generated from field: string currency = 1;
   */
  currency: string;

  /**
   * @generated from field: int64 amount_minor = 2;
   */
  amountMinor: bigint;
};

/**
 * Describes the message live178.v1.Money.
 * Use `create(MoneySchema)` to create a new message.
 */
export const MoneySchema: GenMessage<Money> = /*@__PURE__*/
  messageDesc(file_live178_v1_common, 2);

/**
 * @generated from message live178.v1.OperationResult
 */
export type OperationResult = Message<"live178.v1.OperationResult"> & {
  /**
   * @generated from field: bool accepted = 1;
   */
  accepted: boolean;

  /**
   * @generated from field: string resource_id = 2;
   */
  resourceId: string;

  /**
   * @generated from field: string revision = 3;
   */
  revision: string;
};

/**
 * Describes the message live178.v1.OperationResult.
 * Use `create(OperationResultSchema)` to create a new message.
 */
export const OperationResultSchema: GenMessage<OperationResult> = /*@__PURE__*/
  messageDesc(file_live178_v1_common, 3);

/**
 * @generated from message live178.v1.RequestMetadata
 */
export type RequestMetadata = Message<"live178.v1.RequestMetadata"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string trace_id = 2;
   */
  traceId: string;

  /**
   * @generated from field: google.protobuf.Timestamp served_at = 3;
   */
  servedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.RequestMetadata.
 * Use `create(RequestMetadataSchema)` to create a new message.
 */
export const RequestMetadataSchema: GenMessage<RequestMetadata> = /*@__PURE__*/
  messageDesc(file_live178_v1_common, 4);

/**
 * @generated from message live178.v1.AuditSnapshot
 */
export type AuditSnapshot = Message<"live178.v1.AuditSnapshot"> & {
  /**
   * @generated from field: google.protobuf.Struct before = 1;
   */
  before?: JsonObject | undefined;

  /**
   * @generated from field: google.protobuf.Struct after = 2;
   */
  after?: JsonObject | undefined;
};

/**
 * Describes the message live178.v1.AuditSnapshot.
 * Use `create(AuditSnapshotSchema)` to create a new message.
 */
export const AuditSnapshotSchema: GenMessage<AuditSnapshot> = /*@__PURE__*/
  messageDesc(file_live178_v1_common, 5);

/**
 * @generated from message live178.v1.Actor
 */
export type Actor = Message<"live178.v1.Actor"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;
};

/**
 * Describes the message live178.v1.Actor.
 * Use `create(ActorSchema)` to create a new message.
 */
export const ActorSchema: GenMessage<Actor> = /*@__PURE__*/
  messageDesc(file_live178_v1_common, 6);

